import Vue from 'vue'

import service from './service'

Vue.use(service)



// WEBPACK FOOTER //
// ./src/plugins/install/index.js